import "../App.css"

import React, { useState } from "react";
import { Button, Container} from "@mui/material";

import { useAppCtx } from "../app/AppCtx";
import { CxGrid } from "../cmx/CxGrid"
import { CxTitle, CxInfo } from "../cmx/CxTypography"
import {CxTextField, CxPasswordField} from "../cmx/CxForm";
import {CxFormFeedback} from "../cmx/CxFeedback";
import {Crew} from "../domain/Crew";
import {initialCall, runningCall} from "../gateway/CallService";
import {crewLogin, crewPwChange} from "../gateway/CrewService";
import {ValidationUtil} from "../lib/ValidationUtil";


export function Render({type}) {
    //
    // config per type
    //
    const typeCfg = {
        Login: {
            label           : "Anmeldung",
            initialValues   : Crew.getLoginFormValues(),
            initialErrors   : Crew.getLoginFormErrors(),
            requiredFields  : Crew.getLoginFormRequiredFields(),
            isLogin         : true,
            isPwChange      : false,

        },
        PwChange : {
            label           : "Passwort ändern",
            initialValues   : Crew.getPwChangeFormValues(),
            initialErrors   : Crew.getPwChangeFormErrors(),
            requiredFields  : Crew.getPwChangeFormRequiredFields(),
            isLogin         : false,
            isPwChange      : true
        }
    };

    const cfg = typeCfg[type];

    //
    // states
    //
    const { handleAction, isLoggedIn, user, currentData } = useAppCtx();

    const [formValues, setFormValues] = useState(cfg.initialValues);
    const [formErrors, setFormErrors] = useState(cfg.initialErrors);
    const [call, setCall] = useState (initialCall());

    //
    // handers
    //
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormValues((prev) => ({ ...prev, [name]: value.trim() }));
        setFormErrors((prev) => ({ ...prev, [name]: false }));
    };

    const handleSubmitLogin = async() => {

        // validate
        const errorsCopy = { ...formErrors }; // Create a copy of the errors object
        const isValid = validate(formValues, errorsCopy);

        if (!isValid) {
            setFormErrors(errorsCopy);          // Update errors in state
            return
        }

        // submit login
        setCall(runningCall())
        const responseCall = await crewLogin(formValues);

        if (responseCall.isError) {
            setCall(responseCall)
            return
        }

        const user = responseCall.result;
        const action = user.login_reset_pw === 1 ? "pwChange" : "userLogin";
        handleAction(action, user)
    };


    const handleSubmitPwChange = async() => {
        // validate
        const errorsCopy = { ...formErrors };
        const isValid = validate(formValues, errorsCopy);

        if (!isValid) {
            setFormErrors(errorsCopy);
            return
        }

        // submit pw change
        setCall(runningCall())

        const currentUser = isLoggedIn ? user : currentData;
        const params = {
            login_name: currentUser.login_name,
            login_pw: formValues['login_pw']
        }

        const responseCall = await crewPwChange(params);

        if (responseCall.isError) {
            setCall(responseCall);
            return
        }

        if (!isLoggedIn) {
            handleAction("userLogin", currentUser);
        }
    };


    //
    // validation
    //
    function validate(formValues, formErrors) {
        let isValid = true;

        // reset error message
        setCall(initialCall);

        // trim leading and trailing blanks
        ValidationUtil.trimTextFields(formValues)

        // validate required fields and return result
        isValid = ValidationUtil.required(formValues, formErrors, cfg.requiredFields);

        // PwChange validations
        if (isValid && cfg.isPwChange) {
            const pw = formValues['login_pw'];
            const pw2= formValues['login_pw2'];

            // check minimum length 8 and at least 1 number
            if (pw.length < 8 || !/\d/.test(pw))  {
                isValid = false;
                formErrors['login_pw'] = "Das Passwort muss mindestens 8 Zeichen lang sein und eine Zahl enthalten.";
            }

            // check if passwords are equal
            if (pw !== pw2) {
                isValid = false;
                formErrors['login_pw2'] = "Die Passwort Besätigung ist nicht identisch mit dem neuen Passwort."
            }
        }

        // return validaion result
        return isValid;
    }

    //
    // form inputs
    //
    const formLoginField = (field, label) => {
        return <CxTextField field={field} label={label} maxLength={255}
                            handleChange={handleChange} formValues={formValues} formErrors={formErrors} />
    }

    const formPasswordField = (field, label) => {
        return <CxPasswordField field={field} label={label} maxLength={32}
                                handleChange={handleChange} formValues={formValues} formErrors={formErrors} />
    }

    const renderLogin = () => {
        return (
            <>
                <CxGrid size="xl">{ formLoginField("login_name", "Benutzername")}</CxGrid>
                <CxGrid size="xl">{ formPasswordField("login_pw", "Passwort")}</CxGrid>

                <CxGrid size="xl" sx={{ display: 'flex', justifyContent: 'flex-end' }} >
                    <Button variant="contained" onClick={handleSubmitLogin}>
                        Login
                    </Button>
                </CxGrid>
            </>
        );
    }

    const renderPwChange = () => {
        return (
            <>
                <CxInfo sx={{mb: 1}}>Das neue Passwort muss mindestens 8 Zeichen lang sein und 1 Zahl enthalten.</CxInfo>

                <CxGrid size="xl">{ formPasswordField("login_pw", "Neues Passwort")}</CxGrid>
                <CxGrid size="xl">{ formPasswordField("login_pw2", "Neues Passwort bestätigen")}</CxGrid>

                <CxGrid size="xl" sx={{ display: 'flex', justifyContent: 'flex-end' }} >
                    <Button variant="contained" onClick={handleSubmitPwChange}>
                        Passwort wechseln
                    </Button>
                </CxGrid>
            </>
        );
    }

    //
    // return form content
    //
    return (
        <Container className="UserLogin" maxWidth="xs">
            <CxGrid container spacing={2}>

                <CxGrid size="xl"><CxTitle>{cfg.label}</CxTitle></CxGrid>
                <CxFormFeedback call={call} prefix="" />

                { cfg.isLogin    && renderLogin() }
                { cfg.isPwChange && renderPwChange() }

            </CxGrid>
        </Container>
    );
}

// --------------------------------------------------------------------------------------------------------------------
// Login and PwChange
// --------------------------------------------------------------------------------------------------------------------

export function Login() {
    return <Render type="Login" />
}

export function PwChange() {
    return <Render type="PwChange" />
}

// --------------------------------------------------------------------------------------------------------------------
// The end.